// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"Tooltip_tooltip__Xy3y1","text":"Tooltip_text__ARDeF","divider":"Tooltip_divider__Z4Pcr"};